module.exports = __webpack_public_path__ + "img/img_left_nav_money_hover.22a227e6.svg";